import React from 'react';

const CheckIcon = ({ fill = "#717680", width = "16", height = "16" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <path d="M13.3333 4L6 11.3333L2.66667 8" stroke={fill} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default CheckIcon;